module.exports = __webpack_public_path__ + "img/album01_14.579365f9.jpg";